export const LogoMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 40 40" fill="none" className={className} aria-hidden="true">
    <path
      d="M20 12.5 L11.8 26.2 M20 12.5 L28.2 26.2 M13.6 29.5 L26.4 29.5"
      stroke="#3A3F4B"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="20" cy="9" r="5.5" fill="#8C9A86" />
    <circle cx="9" cy="30" r="5" fill="#0B0C0E" stroke="#8C9A86" strokeWidth="1.5" />
    <circle cx="31" cy="30" r="5" fill="#0B0C0E" stroke="#8C9A86" strokeWidth="1.5" />
  </svg>
);

export default function Logo({ className = "" }) {
  return (
    <span data-testid="brand-logo" className={`group flex items-center gap-2.5 ${className}`}>
      <LogoMark className="h-7 w-7 shrink-0 transition-transform duration-300 group-hover:rotate-12" />
      <span className="font-display font-extrabold text-base sm:text-lg tracking-tight text-[#EAE6E1]">
        Multigroup<span className="text-[#8C9A86]">network</span>
      </span>
    </span>
  );
}
